import { tag } from './reducers';
export default tag;
